import { useMemo, useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { buildValidationSchema } from "../utils/buildValidationSchema";

export const useDynamicValidationResolver = (visibleFields) => {
    const validationSchema = useMemo(() => buildValidationSchema(visibleFields), [visibleFields]);
    const featureTypeMap = useMemo(
        () =>
            (visibleFields || []).reduce((accumulator, field) => {
                accumulator[field.name] = {
                    type: String(field.type || "").toLowerCase(),
                    section: field.section || null,
                    required: !!field.required,
                };
                return accumulator;
            }, {}),
        [visibleFields]
    );

    const dynamicResolver = useCallback(
        async (values, context, options) => {
            const arrayValuedFields = Object.entries(values || {})
                .filter(([, value]) => Array.isArray(value))
                .map(([name, value]) => ({
                    name,
                    length: value.length,
                    expectedType: featureTypeMap[name]?.type || null,
                    section: featureTypeMap[name]?.section || null,
                }));
            const resolver = yupResolver(validationSchema);
            const result = await resolver(values, context, options);
            const errorSummary = Object.entries(result?.errors || {}).map(([name, error]) => ({
                name,
                type: featureTypeMap[name]?.type || null,
                section: featureTypeMap[name]?.section || null,
                message: error?.message || null,
            }));
            return result;
        },
        [featureTypeMap, validationSchema]
    );

    return {
        dynamicResolver,
    };
};
